export enum DeletedItemType {
  DRAFT = 'draft',
  ARTICLE = 'article',
  WORKSPACE = 'workspace',
  GROUP = 'group',
}
